(() => {
  const results = document.getElementById('search-results');
  const input = document.getElementById('search-input');
  const initial = results?.innerHTML || '';
  let timer, controller, sequence = 0;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-header-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.headerOpen);
      if (dialog) { event.preventDefault(); document.querySelector('.shop-nav-drawer[open]')?.close(); dialog.showModal(); if (dialog.id === 'search-dialog') input.focus(); }
    }
    if (event.target.closest('[data-header-close]')) event.target.closest('dialog').close();
  });
  document.querySelectorAll('[data-header-dialog]').forEach(dialog => {
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
  });
  input?.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort(); const revision = ++sequence;
    const query = input.value.trim();
    if (!query) { results.innerHTML = initial; results.removeAttribute('aria-busy'); return; }
    results.textContent = results.dataset.loading;
    results.setAttribute('aria-busy', 'true');
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const url = new URL(results.dataset.endpoint + '.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][fields]', 'title,body,tag,variants.sku');
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search failed');
        const data = await response.json();
        if (revision !== sequence) return;
        const products = data.resources?.results?.products || [];
        results.replaceChildren();
        if (!products.length) results.textContent = results.dataset.empty;
        products.forEach(product => {
          const link = document.createElement('a'); link.className = 'search-result';
          const target = new URL(product.url, location.origin);
          if (target.origin !== location.origin) return;
          link.href = target.href;
          const source = product.featured_image?.url || product.image;
          if (source) { const img = document.createElement('img'); img.src = source; img.alt = ''; img.className = 'search-thumb'; link.append(img); }
          const title = document.createElement('strong'); title.textContent = product.title; link.append(title);
          results.append(link);
        });
      } catch (error) {
        if (error.name !== 'AbortError' && revision === sequence) results.textContent = results.dataset.error;
      } finally { if (revision === sequence) results.removeAttribute('aria-busy'); }
    }, 250);
  });
})();
